export function mergeStylexProps(stylexResult, classNameOrStyle, style) {
  const externalClassName = typeof classNameOrStyle === 'string' ? classNameOrStyle : undefined;
  const externalStyle = typeof classNameOrStyle === 'object' ? classNameOrStyle : style;
  const mergedClassName = [stylexResult.className, externalClassName].filter(Boolean).join(' ');
  const mergedStyle = externalStyle ? Object.assign({}, stylexResult.style, externalStyle) : stylexResult.style;
  return Object.assign({}, stylexResult, {
    className: mergedClassName || undefined,
    style: mergedStyle
  });
}